import TextInput from '@/components/refinedev/TextInput';
import TextareaInput from '@/components/refinedev/TextareaInput';
import Section from '@/components/surface/Section';
import DatepickerInput from '@/components/refinedev/DatepickerInput';
import SelectInput from '@/components/refinedev/SelectInput';
import {TaskPriorities, TaskStatuses} from './types';
import MemberArrayInput from './components/member-array-input';
import formatter from '@/lib/formatter';
import {Tabs, TabsList, TabsTrigger, TabsContent} from '@/shadcn_components/ui/tabs';
import {ThousandSeparatorTextInput} from '@/components/refinedev/MaskTextInput';
import CheckboxInput from '@/components/refinedev/CheckboxInput';
import {useForm, useFormContext, useWatch} from 'react-hook-form';
import {useEffect} from 'react';

const TaskForm = () => {
  return (
    <Tabs defaultValue="general_info">
      <TaskForm_TabsList />
      <TaskForm_TaskContents />
    </Tabs>
  );
};

const TaskForm_TabsList = () => (
  <TabsList className="flex gap-x-4 bg-primary">
    <TabsTrigger className="text-white" value="general_info">
      Thông tin chung
    </TabsTrigger>
    <TabsTrigger className="text-white" value="members">
      Nhân sự
    </TabsTrigger>
    {/* <TabsTrigger value="documents">Tài liệu đính kèm</TabsTrigger> */}
  </TabsList>
);

const TaskForm_TaskContents = () => (
  <>
    <TabsContent value="general_info" forceMount>
      <Section
        className="w-full mx-auto"
        title="Thông tin chung"
        subtitle="Nhập thông tin cơ bản của công việc">
        <TaskForm_GeneralInfo />
      </Section>
    </TabsContent>

    <TabsContent value="members" forceMount>
      <Section
        className="w-full mx-auto"
        title="Nhân sự"
        subtitle="Chọn nhân sự tham gia vào công việc">
        <MemberArrayInput />
      </Section>
    </TabsContent>

    {/* <TabsContent value="documents" forceMount>
    <Section title="Tài liệu đính kèm" subtitle="Tài liệu liên quan đến dự án">
    <TextInput source="attachments" label="Tài liệu đính kèm" />
    </Section>
</TabsContent> */}
  </>
);

const TaskForm_GeneralInfo = () => {
  const autoStartDate = useWatch({
    name: 'options.auto_start_date',
  });
  const actual_end_date = useWatch({
    name: 'actual_end_date',
  });
  const status = useWatch({
    name: 'status',
  });

  const {setValue} = useFormContext();

  useEffect(() => {
    if (actual_end_date && actual_end_date instanceof Date && !isNaN(actual_end_date.getTime())) {
      setValue('status', 'completed', {shouldDirty: true});
    }
  }, [actual_end_date, setValue]);

  useEffect(() => {
    if (status !== 'completed') {
      setValue('actual_end_date', null, {shouldDirty: true});
    } else setValue('actual_end_date', new Date(), {shouldDirty: true});
  }, [status, setValue]);

  return (
    <div className="w-full">
      <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2">
        <TextInput source="project_id" label="Dự án" hidden />
        <TextInput source="name" label="Tên công việc" />
        <TextInput source="stakeholders" label="Các bên liên quan chính" />
      </div>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2">
        {' '}
        {/* Budget Section */}
        <ThousandSeparatorTextInput source="requested_budget" label="Ngân sách yêu cầu" />
        <ThousandSeparatorTextInput source="approved_budget" label="Ngân sách được duyệt" />
      </div>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2">
        {/* Planning Section */}
        <SelectInput
          source="priority"
          label="Độ ưu tiên"
          choices={TaskPriorities}
          defaultValue={TaskPriorities[0].id}
        />
        <SelectInput
          source="status"
          label="Trạng thái"
          choices={TaskStatuses}
          defaultValue={TaskStatuses[0].id}
        />
      </div>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2 border-t mt-2 pt-2 border-b mb-2 pb-2">
        <div>
          <div>Kế hoạch</div>
          <CheckboxInput source="options.hide_initial_plan" label="Ẩn kế hoạch" />
          {/* Initial Plan */}
          <ThousandSeparatorTextInput
            source="expected_work_days"
            label="Số ngày làm việc dự kiến"
          />
          <DatepickerInput source="start_date" label="Ngày bắt đầu" readOnly={autoStartDate} />
          <ThousandSeparatorTextInput source="start_date_offset" label="Cộng trừ ngày" />
          <DatepickerInput source="initial_end_date" label="Ngày kết thúc dự kiến" readOnly />
          <ThousandSeparatorTextInput source="delay_days" label="Số ngày chậm tiến độ" readOnly />
        </div>
        <div>
          <div>Kế hoạch điều chỉnh</div>
          <CheckboxInput source="options.hide_rescheduled" label="Ẩn kế hoạch điều chỉnh" />
          {/* Rescheduled Plan */}
          <ThousandSeparatorTextInput
            source="rescheduled_work_days"
            label="Số ngày làm việc (điều chỉnh)"
            readOnly
          />
          <DatepickerInput
            source="rescheduled_start_date"
            label="Ngày bắt đầu (điều chỉnh)"
            readOnly
          />
          <ThousandSeparatorTextInput
            source="rescheduled_start_date_offset"
            label="Cộng trừ ngày"
          />
          <DatepickerInput
            source="rescheduled_end_date"
            label="Ngày kết thúc (điều chỉnh)"
            readOnly
          />
          <ThousandSeparatorTextInput
            source="rescheduled_delay_days"
            label="Số ngày chậm tiến độ"
            readOnly
          />
        </div>
        <div>
          <div>Thực tế</div>
          <CheckboxInput source="options.hide_actual" label="Ẩn thực tế" />
          {/* Actual Data */}
          <ThousandSeparatorTextInput
            source="actual_work_days"
            label="Số ngày làm việc thực tế"
            readOnly
          />
          <DatepickerInput source="actual_start_date" label="Ngày bắt đầu (thực tế)" readOnly />
          <DatepickerInput source="actual_end_date" label="Ngày kết thúc (thực tế)" />
        </div>
      </div>
      <CheckboxInput
        source="options.auto_start_date"
        label="Tự động cập nhật ngày bắt đầu (workflow)"
      />
      <TextareaInput
        className="lg:col-span-3 md:col-span-2 sm:col-span-1"
        source="description"
        label="Mô tả"
      />
    </div>
  );
};

// use in task-node component
TaskForm.transformBeforeSaveInWorkflow = inputData => {
  // tự động chỉnh ngày kết thúc thực tế và trạng thái công việc
  let status = inputData.status || TaskStatuses[0].id;
  // nếu có ngày kết thúc thực tế thì trạng thái phải là hoàn thành
  if (inputData.actual_end_date) {
    status = 'completed';
  }
  // nếu trạng thái không phải là hoàn thành thì ngày kết thúc thực tế phải null
  if (status !== 'completed') {
    inputData.actual_end_date = null;
  }
  return {
    ...inputData,
    status,
  };
};

// use when submit
TaskForm.transformBeforeSave = inputData => {
  // tự động chỉnh ngày kết thúc thực tế và trạng thái công việc
  let status = inputData.status || TaskStatuses[0].id;
  // nếu có ngày kết thúc thực tế thì trạng thái phải là hoàn thành
  if (inputData.actual_end_date) {
    status = 'completed';
  }
  // nếu trạng thái không phải là hoàn thành thì ngày kết thúc thực tế phải null
  if (status !== 'completed') {
    inputData.actual_end_date = null;
  }

  const data = {
    ...inputData,
    status,
    // options: JSON.stringify(inputData.options || {}),
    members: inputData.members
      ? JSON.stringify(inputData.members?.map?.(m => ({id: m.id, role: m.pivot.role || ''})) || [])
      : undefined,
    start_date: inputData.start_date ? formatter.formatDateSQL(inputData.start_date) : undefined,
    initial_end_date: inputData.initial_end_date
      ? formatter.formatDateSQL(inputData.initial_end_date)
      : undefined,
    rescheduled_end_date: inputData.rescheduled_end_date
      ? formatter.formatDateSQL(inputData.rescheduled_end_date)
      : undefined,
    actual_end_date: inputData.actual_end_date
      ? formatter.formatDateSQL(inputData.actual_end_date)
      : undefined,
    project: undefined, // remove project from data because of circular reference
    workflow: undefined, // remove workflow from data as it is not needed in the backend
  };

  return data;
};

TaskForm.defaultValues = {options: {auto_start_date: true}};

TaskForm.GeneralInfo = TaskForm_GeneralInfo;
TaskForm.TabsList = TaskForm_TabsList;
TaskForm.TaskContents = TaskForm_TaskContents;

export default TaskForm;
